import React, { Dispatch, FC, SetStateAction, useContext } from 'react'
import { Grid, useTheme } from '@mui/material'
import { Add as AddIcon, PhotoCameraOutlined } from '@mui/icons-material'
import { FormattedMessage } from 'react-intl'
import SvgSurface from '../../../icons/SvgSurface'
import { OffreModel } from '../types/OffreModel'
import { makeStyles } from 'tss-react/mui'
import styles from '../../../styles'
import { WHITE } from '../../../theme'
import { ResponsiveContext } from '../../../utils/context/ResponsiveContext'

interface PhotosBlocEnCommunProps {
	offre: OffreModel
	setAfficherVisionneusePhotos: Dispatch<SetStateAction<boolean>>,
	setAfficherVisionneusePlan: Dispatch<SetStateAction<boolean>>,
	setAfficherVisite3D: Dispatch<SetStateAction<boolean>>,
}

const PhotosBlocEnCommun: FC<PhotosBlocEnCommunProps> = (
	{
		offre,
		setAfficherVisionneusePhotos,
		setAfficherVisionneusePlan,
		setAfficherVisite3D
	}) => {
	const theme = useTheme()
	const { isLargeScreen } = useContext(ResponsiveContext)
	const { classes } = useStyles({ isLargeScreen })
	return (
		<>
			{
				(offre.tags || []).length > 0 && (
					<div className={classes.tagsContainer}>
						{
							offre.tags.map(
								(tag, index) => (
									<span
										className={classes.tagStyle}
										style={{
											backgroundColor: tag.couleur
										}}
										key={`${tag.libelle}-${index}`}
									>
										{tag.libelle}
									</span>
								)
							)
						}
					</div>
				)
			}

			<Grid
				container
				item
				xs={11}
				md={8}
				alignItems="center"
				className={classes.mediaContainer}
				wrap="nowrap"
			>
				<div className={classes.media} onClick={(e) => {
					e.stopPropagation()
					setAfficherVisionneusePhotos(true)
				}}>
					<PhotoCameraOutlined />

					<FormattedMessage
						id="offre.photos.nbPhotos"
						defaultMessage="{nbPhotos} photos"
						description="Nombre de photos"
						values={{
							nbPhotos: offre.photos.length
						}}
					/>
				</div>

				{
					offre.plan && (
						<div className={classes.media} onClick={(e) => {
							e.stopPropagation()
							setAfficherVisionneusePlan(true)
						}}>
							<SvgSurface width={25} height={25} color={theme.palette.blue.main} />

							<FormattedMessage
								id="offre.photos.plan"
								defaultMessage="Plan du bien"
								description="Bouton de plan du bien"
							/>
						</div>
					)
				}

				{
					offre.visite3D && (
						<div className={classes.media} onClick={(e) => {
							e.stopPropagation()
							setAfficherVisite3D(true)
						}}>
							{/* TODO Changer l'icone quand dispo */}
							<AddIcon />

							<FormattedMessage
								id="offre.photos.visite"
								defaultMessage="Visite 3D"
								description="Bouton de visite 3D"
							/>
						</div>
					)
				}
			</Grid>
		</>
	)
}

const useStyles = makeStyles<{ isLargeScreen: boolean }>()((theme, { isLargeScreen }) => ({
	...styles(theme),
	tagsContainer: {
		position: 'absolute',
		left: isLargeScreen ? 25 : 30,
		top: isLargeScreen ? 23 : 22
	},
	tagStyle: {
		height: 26,
		borderRadius: 21,
		textTransform: 'uppercase',
		padding: '7px 10px',
		...styles(theme).text23,
		color: WHITE,
		boxSizing: 'border-box',
		'&:not(:first-child)': {
			marginLeft: 10
		}
	},
	mediaContainer: {
		backgroundColor: WHITE,
		borderRadius: 42,
		padding: '12px 10px',
		position: 'absolute',
		bottom: 19,
		left: '50%',
		transform: 'translate(-50%, 0)',
		width: 'max-content',
		boxSizing: 'content-box'
	},
	media: {
		...styles(theme).text4,
		padding: isLargeScreen ? '0 15px' : '0 10px',
		display: 'flex',
		alignItems: 'center',
		cursor: 'pointer',
		'& > svg': {
			marginRight: isLargeScreen ? 10 : 5
		},
		'&:not(:first-child)': {
			borderLeft: `1px solid ${theme.palette.blue.main}`
		}
	}
}))

export default PhotosBlocEnCommun